// extracted by mini-css-extract-plugin
module.exports = {"page-container":"Geography_page-container__hRIYs"};